import {Collapse, Tag, Empty} from "antd";
import className from "classnames/bind";
import {issueRef, markKey, IssueMarkSelect} from "./IssueMark";
import style from "../style/SiteCrawler.module.scss";

const cn = className.bind(style);

const SEVERITY = [
	{key: 'error', label: 'Lỗi nặng', color: 'red'},
	{key: 'warning', label: 'Cảnh báo', color: 'orange'},
	{key: 'info', label: 'Thông tin', color: 'blue'},
];

/** Một issue cấp site kèm URL trang liên quan (nếu có) + danh sách URL trong meta. */
function IssueRow({issue, onOpenPage, marks, onMark}) {

	const urls = issue.meta && Array.isArray(issue.meta.urls) ? issue.meta.urls : null;

	// Đánh dấu xử lý — chỉ hiện khi issue có ref ổn định + trang có nạp marks.
	const ref = issueRef(issue);
	const status = ref && marks ? marks.get(markKey(issue.type, ref)) || null : null;
	const dim = status === 'resolved' || status === 'ignored';

	return (
		<div className={cn('issueItem')} style={dim ? {opacity: 0.55} : undefined}>
			<div style={{display: 'flex', gap: 10, alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap'}}>
				<div style={{flex: '1 1 320px', textDecoration: status === 'resolved' ? 'line-through' : 'none'}}>{issue.message}</div>
				{ref && onMark && (
					<IssueMarkSelect status={status} onChange={(v) => onMark(issue.type, ref, v)} />
				)}
			</div>

			{issue.url && (
				<div className={cn('issueMeta')}>
					<span className={cn('issueLink')} onClick={() => issue.page_id && onOpenPage?.(issue.page_id)}>
						{issue.url}
					</span>
				</div>
			)}

			{urls && <div className={cn('issueMeta')}>{urls.join('\n')}</div>}
		</div>
	);
}

/**
 * Báo cáo Tầng B — vấn đề CẤP SITE (duplicate, broken link, orphan, redirect, server
 * error...). Issue theo từng trang (type `page_*`) được tách sang PageIssueList.
 */
function IssueSection({issues, onOpenPage, marks, onMark}) {

	if (!issues) return null;

	const total = SEVERITY.reduce((s, sv) => s + (issues[sv.key]?.length || 0), 0);

	if (total === 0) {
		return <Empty description="Không phát hiện vấn đề cấp site nào 🎉" />;
	}

	const items = SEVERITY
		.filter((sv) => (issues[sv.key]?.length || 0) > 0)
		.map((sv) => ({
			key: sv.key,
			label: (
				<span>
					<Tag color={sv.color}>{sv.label}</Tag>
					<strong>{issues[sv.key].length}</strong> mục
				</span>
			),
			children: (
				<div>
					{issues[sv.key].map((iss) => (
						<IssueRow key={iss.id} issue={iss} onOpenPage={onOpenPage} marks={marks} onMark={onMark} />
					))}
				</div>
			),
		}));

	return <Collapse items={items} defaultActiveKey={['error', 'warning']} />;
}

export default IssueSection;
